<template>
  <v-dialog
    v-model="dialog"
    width="500"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="primary"
        dark
        :disabled="disabled"
        v-on="on"
      >
        {{ btnText }}
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span>Teste de envio de mensagem</span>
      </v-card-title>
      <v-card-text>
        <v-layout>
          <v-flex
            xs12
          >
            <input-text
              id="input:value"
              v-model="testValue"
              :label="label"
            />
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-layout
          justify-end
          align-center
        >
          <v-flex xs3>
            <v-btn
              color="gray"
              outline
              @click="dialog = false"
            >
              Cancelar
            </v-btn>
          </v-flex>
          <v-flex xs3>
            <v-btn
              color="success"
              @click="sendTest(type)"
            >
              Enviar
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import MessageRequest from 'Domain/generate-messages/MessageRequest';
import InputText from 'Support/components/inputs/InputText.vue';

export default {
  name: 'MessageTestSend',
  components: { InputText },
  props: {
    disabled: {
      type: Boolean,
    },
    label: {
      type: String,
      default: '',
    },
    btnText: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    value: {
      type: Object,
      default() {
        return {
          mensagemDeEmail: '',
          mensagemDePush: '',
          mensagemDeSms: '',
          tituloDoEmail: '',
          tituloDoPush: '',
        };
      },
    },
  },
  data: () => ({
    dialog: false,
    testValue: '',
    requestClass: MessageRequest,
  }),
  computed: {
    payload() {
      return this.value;
    },
  },
  methods: {
    sendTest(type) {
      switch (type) {
        case 'sms':
          return this.testSms();
        case 'email':
          return this.testEmail();
        default:
          return this.testPush();
      }
    },
    testSms() {
      this.makeRequestSendTest({
        mensagem: this.payload.mensagemDeSms,
        titulo: '',
        type: 'sms',
        value: this.testValue,
      });
    },
    testPush() {
      this.makeRequestSendTest({
        mensagem: this.payload.mensagemDePush,
        titulo: this.payload.tituloDoPush,
        type: 'push',
        value: this.testValue,
      });
    },
    testEmail() {
      this.makeRequestSendTest({
        mensagem: this.payload.mensagemDeEmail,
        titulo: this.payload.tituloDoEmail,
        type: 'email',
        value: this.testValue,
      });
    },
    makeRequestSendTest(payload) {
      this.callService(
        this.requestClass.sendTest(payload),
        null,
        {
          successMessage: 'Sucesso ao fazer test de envio!',
          errorMessage: 'Falha ao fazer test de envio!',
        },
      );
    },
  },
};
</script>

<style>

</style>
